import {writable} from 'svelte/store'

export function createCalculator(priceStrategy, unitsPerItem) {
    const store = writable({amount: 0, unitsPerItem: unitsPerItem, priceStrategy: priceStrategy});

    function action(node, binding) {
        return {
            update(binding) {
                store.set({amount: binding, unitsPerItem: unitsPerItem, priceStrategy: priceStrategy});
            }
        }
    }

    return [
        store,
        action
    ];
}
